import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c5-five-two-one-two',
  templateUrl: './c5-five-two-one-two.component.html',
  styleUrls: ['./c5-five-two-one-two.component.scss']
})
export class C5FiveTwoOneTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
